import { SyncQueueContent } from "./SyncQueueContent";
import FullScreenLayout from "../layout/FullScreenLayout";

export function SyncQueueListing({ closeModal }: { closeModal: () => void }) {
  return (
    <FullScreenLayout>
      <SyncQueueContent onClose={closeModal} />
    </FullScreenLayout>
  );
}
